import { Component, Input } from '@angular/core';
import { APP_ROLE, USER_APP_ROLE } from '../../interfaces/application.interface';
import { DOMAIN_RESOURCE } from '../../interfaces/resource.interface';
import { USER } from '../../interfaces/user.interface';

@Component({
    selector: 'com-view-roles',
    templateUrl: './view-roles.component.html',
    styleUrls: ['./view-roles.component.scss']
})
export class ViewRolesComponent {

  @Input() flow = 'domain';
  @Input() user: USER;
  @Input() domainResourceMap: {[key: number]: DOMAIN_RESOURCE} = {};
  @Input() userRolesMap: {[key: number]: APP_ROLE} = {};
  @Input() lengthToShow = 4;

  topLevelRoles: USER_APP_ROLE[] = [];
  resourceLevelRoles: USER_APP_ROLE[] = [];

  ngOnChanges({user}): void {
      if(user && user?.currentValue)
          user?.currentValue?.roles.forEach((role: USER_APP_ROLE) => {
              role?.domainResourceId ? this.resourceLevelRoles?.push(role) : this.topLevelRoles?.push(role);
            //   role?.domainResourceId ? this.resourceLevelRoles?.push(this.domainResourceMap[role.domainResourceId]) : this.topLevelRoles?.push(this.userRolesMap[role.role]);
          });
  }
}
